<template>
    <div>
        <el-input v-if="disabled" :disabled="disabled" v-model="dispName" class="width-2x" type="text"></el-input>
        <el-form v-else  :model="regionInfo" :rules="regionRules" ref="regionInfo">
            <el-form-item class="width-2x">
                <el-col :span="8">
                    <el-form-item prop="provinceId">
                        <el-select v-model="regionInfo.provinceId" placeholder="请选择" @change="changeRegion(2, regionInfo.provinceId);">
                            <el-option v-for="province in provinces" :label="province.name" :value="province.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="cityId">
                        <el-select v-model="regionInfo.cityId" placeholder="请选择" @change="changeRegion(3, regionInfo.cityId);">
                            <el-option v-for="city in citys" :label="city.name" :value="city.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="countyId">
                        <el-select v-model="regionInfo.countyId" placeholder="请选择">
                            <el-option v-for="county in countys" :label="county.name" :value="county.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Routes } from '../../app.vues'

    import comnApi from '../../api/comn'

    export default {
        name: 'swb-region',
        desc: '地区组件',   // ---> 参数： item：{}
        props: {
            item: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            //不可编辑时的显示名称
            dispName : {
                type : String,
                default : ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            mustParam: { // 校验-非空
                type: Boolean,
                default: true
            }
        },
        data: function () {
            var self = this;
            let validateCityId = function (rule, value, callback) {
                // alert(self.regionInfo.provinceId);
                if(!Utils.isNoB(self.regionInfo.provinceId)) {
                    if(Utils.isNoB(value) && self.mustParam) {
                        callback(new Error('请选择市区'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let validateCountyId = function (rule, value, callback) {
                // alert(self.regionInfo.provinceId);
                if(!Utils.isNoB(self.regionInfo.cityId) && self.mustParam) {
                    if(Utils.isNoB(value)) {
                        callback(new Error('请选择县乡（区）'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            return {
                provinces: [],
                citys: [],
                countys: [],
                regionInfo: {
                    provinceId: null,
                    cityId: null,
                    countyId: null,
                    regionId: null
                },
                regionRules: {
                    cityId: [
                        {validator: validateCityId, trigger: 'change'}
                    ],
                    countyId: [
                        {validator: validateCountyId, trigger: 'change'}
                    ]
                },
                isTrue: false
            }
        },
        created: function () {
            let self = this;
            //
            self.fetchData();
        },
        watch: {
            item: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    this.fetchData();
                }
            }
        },
        methods: {
            fetchData: function () {
                let self = this;
                self.isTrue = true;
                let item = this.item || {};
                let regionInfo = this.regionInfo;
                regionInfo.provinceId = item.provinceId;
                regionInfo.cityId = item.cityId;
                regionInfo.countyId = item.countyId;
                regionInfo.regionId = item.regionId;
                this.regionInfo = Utils.merge({}, regionInfo);
                self.getRegionsByParentId(1, -1);
            },
            changeRegion: function (level, parentId) {
                let self = this;
                if(level == 1) {
                    self.citys = [];
                    self.regionInfo.cityId = null;
                    self.countys = [];
                    self.regionInfo.countyId = null;
                } else if(level == 2) {
                    self.regionInfo.cityId = null;
                    self.countys = [];
                    self.regionInfo.countyId = null;
                } else if(level == 3) {
                    self.regionInfo.countyId = null;
                }
                if(this.isTrue == false) {
                    self.getRegionsByParentId(level, parentId, true);
                }
            },
            getRegionsByParentId: function (level, parentId, change) {
                let self = this;
                let postData = {};
                postData.parentId = parentId;
                comnApi.getRegionListByParentId(postData, function (result, jqXhr) {
                    if(result.type == "info") {
                        if(level == 1) {
                            self.provinces = result.data;
                            if(self.isTrue && !Utils.isNoB(self.item)) {
                                if(change == null) {
                                    if(self.regionInfo.provinceId == self.item.provinceId) {
                                        self.getRegionsByParentId(2, self.item.provinceId);
                                    } else {
                                        self.regionInfo.provinceId = self.item.provinceId;
                                        self.regionInfo = Utils.merge({}, self.regionInfo);
                                    }
                                } else {
                                    self.regionInfo.provinceId = self.item.provinceId;
                                    self.regionInfo = Utils.merge({}, self.regionInfo);
                                }
                            }
                            //
                        } else if(level == 2) {
                            self.citys = result.data;
                            if(self.isTrue && !Utils.isNoB(self.item)) {
                                if(change == null) {
                                    if(self.regionInfo.cityId == self.item.cityId) {
                                        self.getRegionsByParentId(3, self.item.cityId);
                                    } else {
                                        self.regionInfo.cityId = self.item.cityId;
                                        self.regionInfo = Utils.merge({}, self.regionInfo);
                                    }
                                } else {
                                    self.regionInfo.cityId = self.item.cityId;
                                    self.regionInfo = Utils.merge({}, self.regionInfo);
                                }
                            }
                            //
                        } else if(level == 3) {
                            self.countys = result.data;
                            if(self.isTrue && !Utils.isNoB(self.item)) {
                                if(change == null) {
                                    self.regionInfo.countyId = self.item.countyId;
                                    self.regionInfo = Utils.merge({}, self.regionInfo);
                                } else {
                                    self.regionInfo.countyId = self.item.countyId;
                                    self.regionInfo = Utils.merge({}, self.regionInfo);
                                }
                                self.isTrue = false;
                            }
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                })
            },
            notityChange: function () {
                // 发生变化时向上传递
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['regionInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = 'info';
                        let regionInfo = self.regionInfo;
                        if(!Utils.isNoB(regionInfo.countyId)) {
                            regionInfo.regionId = regionInfo.countyId;
                        } else if(!Utils.isNoB(regionInfo.cityId)) {
                            regionInfo.regionId = regionInfo.cityId;
                        } else if(!Utils.isNoB(regionInfo.provinceId)) {
                            regionInfo.regionId = regionInfo.provinceId;
                        }
                        result.data = regionInfo;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            }
        }
    }

</script>

<style>
    .el-select > .el-input {
        width: auto !important;
    }

    .el-col.el-col-8 .el-form-item .el-select {
        width: auto !important;
    }
</style>




// WEBPACK FOOTER //
// src/compo/comn/Region.vue